<template>
    <div id="dispatch-other-pt-modal">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-sm table-bordered">
                            <thead class="thead-light">
                                <tr v-if="finisehdProductCode">
                                    <th style="width: 40%;" class="thead-light">Producto Terminado</th>
                                    <td>{{ finisehdProductCode }}</td>
                                </tr>
                                <tr>
                                    <th style="width: 40%;" class="thead-light">Mezcla Comercial</th>
                                    <td>{{ commercialMixCode }}</td>
                                </tr>
                                <tr>
                                    <th style="width: 40%;" class="thead-light">Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                    <td>{{ finalHarvest }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-md-12">
                        <label>Producto Terminado:</label>
                    </div>
                    <div class="col-md-12">
                        <v-select @input="showStock(otherPt.code)" :options="ptList" v-model="otherPt"
                            >
                            <span slot="no-options">No se encontraron otros Productos Terminados</span>
                        </v-select>
                    </div>
                    <div class="col-md-12">
                        <table style="margin-bottom: 0px !important" v-if="stock.text" class="table table-sm table-bordered" 
                                    :class="stock.stock > 0? 
                                    'table-supply-stock-success' : 'table-supply-stock-danger'">
                            <tr>
                                <th class="text-left pl-2" style="width: 15% !important;">
                                    <i class="fas fa-cubes"></i>
                                    Stock:
                                </th>
                                <th style="width: 15% !important;" class="text-right pr-2">
                                    <span>{{ stock.text }}</span>
                                </th>
                                <th class="text-left pl-2" style="width: 18% !important;">
                                    <i class="fas fa-seedling"></i>
                                    Cosecha:
                                </th>
                                <th style="width: 8% !important;" class="text-right pr-2">
                                    <span>{{ stock.harvest }}</span>
                                </th>                                                        
                                <th :class="stock.stock > 0? 'border-left-success' : 'border-left-danger'" 
                                    class="text-left pl-2" style="width: 20% !important;">
                                    <i class="fas fa-clock mr-2"></i>
                                    Actualizado:
                                </th>
                                <th class="text-right pr-2" style="width: 15% !important;">
                                    <span>{{ stock.updatedStockAtString }}</span>
                                </th>
                            </tr>
                        </table>
                    </div>
                    <div class="col-md-12 mt-4">
                        <button class="btn btn-success btn-block" @click="save">
                            <i class="fas fa-save"></i>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Put, Get } from "@/helper/axios";
export default {
    name: "OtherPtModal",
    props: [
        "sampleId",
        "detailId",
        "commercialMixCode",
        "ptList",
        "finisehdProductCode",
        "finalHarvest"
    ],
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Put,
            Get,
            otherPt: {},
            stock: {}
        };
    },
    methods: {
        save() {
            this.$store.commit("setLoading", true);
            let data = {
                finishedProductCode: this.otherPt.code,
                detailId: this.detailId
            }
            this.Put(`${this.apiUrl}v1/requestsample/${this.sampleId}/details/saveOtherPt`, data, () => {
                    this.$store.commit("setLoading", false);
                    this.otherPt = {}
                    window.toastr.success('Producto Terminado Actualizado Correctamente.');
                    this.$emit("saveOtherPt");
                }
            );
        },
        showStock(sku) {
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=PT'
            if (this.finalHarvest)
                data += '&Harvest=' + this.finalHarvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                this.stock = res.data              
            });
            this.$store.commit("setLoading", false);
        },
    },
};
</script>

<style scoped></style>
